<div class="container" *transloco="let t">
  <div class="row mt-3">
    <div class="col-xl-9 col-lg-8">

      <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
        <h1 class="h3 mb-0">{{ t('navigation.notifications') }}</h1>
        <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="isAnythingLoading() || !unreadCount"
          (click)="markAllAsRead()">{{ t('common.mark_all_read') }}</button>
      </div>

      <div class="d-flex align-items-center gap-1 mb-3" role="group" [attr.aria-label]="t('common.filter')">
        <span class="badge badge-pill clickable" (click)="chooseUnreadOnly(false)"
          [ngClass]="{ 'badge-primary': !state().unreadOnly, 'badge-secondary': state().unreadOnly, disabled: isAnythingLoading() }">{{ t('common.all') }}</span>
        <span class="badge badge-pill clickable" (click)="chooseUnreadOnly(true)"
          [ngClass]="{ 'badge-primary': state().unreadOnly, 'badge-secondary': !state().unreadOnly, disabled: isAnythingLoading() }">{{ t('common.unread') }}
          @if (unreadCount) {
            ({{ unreadCount }})
          }
        </span>
      </div>

      @if (actionFailed()) {
        <alert [type]="'danger'" [dismissible]="true" (onClosed)="actionFailed.set(false)">{{ t('error.not_done_try_again') }}</alert>
      }

      @let page = notificationsPage();
      @if (page?.data?.length) {
        <ul class="list-group mb-3">
          @for (notification of page.data; track notification.id) {
            <li class="list-group-item d-flex gap-3 align-items-start" [ngClass]="{ 'notification-unread': !notification.read }">
              <span class="notification-dot mt-2" aria-hidden="true"></span>
              @if (!notification.read) {
                <span class="visually-hidden">{{ t('common.unread') }}</span>
              }

              <div class="flex-grow-1 min-width-0">
                <ng-template #heading>
                  @if (notification.label.text) {
                    <span>{{ notification.label.text }}</span>
                  } @else if (notification.label.translationKey) {
                    <span *transloco="let tl; scope: notification.label.translationScope ?? undefined">{{ tl(notification.label.translationKey) }}</span>
                  }
                  @if (notification.context; as context) {
                    &nbsp;|&nbsp;
                    @if (context.text) {
                      <span>{{ context.text }}</span>
                    } @else if (context.translationKey) {
                      <span *transloco="let tc; scope: context.translationScope ?? undefined">{{ tc(context.translationKey) }}</span>
                    }
                  }
                </ng-template>

                @if (canOpen(notification)) {
                  <button type="button" class="btn btn-link p-0 text-left notification-heading" [disabled]="isAnythingLoading()"
                    (click)="open(notification)"><ng-container *ngTemplateOutlet="heading"></ng-container></button>
                } @else {
                  <span class="notification-heading"><ng-container *ngTemplateOutlet="heading"></ng-container></span>
                }

                @if (notification.teaser) {
                  <p class="mb-1 text-wrap">{{ notification.teaser }}</p>
                }
                <small class="text-muted">
                  {{ notification.createdAt | date: 'medium' }}
                  @if (gone().has(notification.id)) {
                    · {{ t('common.no_longer_available') }}
                  }
                </small>
              </div>

              <div class="d-flex flex-column flex-sm-row gap-1 flex-shrink-0">
                <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="isAnythingLoading()"
                  (click)="toggleRead(notification)">{{ notification.read ? t('common.mark_unread') : t('common.mark_read') }}</button>
                <button type="button" class="btn btn-sm btn-outline-danger" [disabled]="isAnythingLoading()"
                  [attr.aria-label]="t('common.delete')" [title]="t('common.delete')" (click)="remove(notification)">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </li>
          }
        </ul>
      }

      @if (page?.meta && page.meta.last_page > 1) {
        <frontend-pagination-type-three
          [classes]="'pg-purple justify-content-center'" [loading]="isAnythingLoading()"
          [meta]="page.meta" [lastPage]="page.meta.last_page"
          [links]="page.links" (changePage)="changePage($event)">
        </frontend-pagination-type-three>
      }

      @if (isAnythingLoading()) {
        <multisite-loader-globe-animation-detail width="100" height="100" class="my-3"></multisite-loader-globe-animation-detail>
      }

      @if (failed()) {
        <alert [type]="'danger'">
          <div class="text-center my-5">{{ t('error.something_went_wrong') }}</div>
        </alert>
      }

      @if (!isAnythingLoading() && !failed() && page && !page.data.length) {
        <alert [type]="'info'">
          <div class="text-center my-5">{{ t('common.none_yet') }}</div>
        </alert>
      }
    </div>

    <div class="col-xl-3 col-lg-4">
      <div class="feed-filters">
        <div class="filters-body">
          <div>
            <span class="mb-2 filters-title d-block">{{ t('navigation.settings') }}</span>
            <ul class="list-unstyled mb-0">
              <li><a [routerLink]="['/account/notifications']">{{ t('account.notification_emails.title') }}</a></li>
              <li><a [routerLink]="['/account/subscriptions']">{{ t('account.subscriptions.title') }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
